import styled, { css } from 'styled-components';

//TODO: Hard coded colors would be replaced by ui-bricks theme variables
export const BadgeWrapper = styled.span`
    ${({ theme }) => css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        max-width: 100%;
        padding: 4px 10px;
        border-radius: 10px;
        box-sizing: border-box;
        text-align: center;
        vertical-align: middle;
        white-space: normal;
        overflow-wrap: break-word;
        font-size: 14px;
        font-weight: 400;
        line-height: 100%;
        background-color: ${theme.uiBricks?.dashboardDrActivityDashboardCardDrawerBackgroundColor || '#CFE3FB'};
        color: ${theme.uiBricks?.primaryAccentColor || '#0B3D78'};
    `}
`;
